import { FC } from 'react'
import { SvgProps } from './svgProps'

const TshirtIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M31.494 14.055l-4.601-11.001-5.578-2.426h-10.709l-4.518 1.962c-0.686 0.304-1.221 0.846-1.509 1.518l-0.007 0.019-4.154 9.928 4.681 2.577 2.489-4.566v19.323h16.745v-19.309l2.481 4.551z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M10.748 0.627c0 2.949 2.332 5.34 5.208 5.34s5.208-2.391 5.208-5.34"
    ></path>
  </svg>
)

export default TshirtIcon
